import { ItemTypeConsts } from 'client/util/Constants';

export const simulations = {
  [ItemTypeConsts.device]: [
    {
      label: 'Mac System Agent Install',
      iframeUrl: 'https://xd.adobe.com/embed/2bfd5885-83ee-4213-4da6-cd8639d07a4d-5dcc/',
      url: 'https://jumpcloud.com/simulations/mac-system-agent-install',
    },
    {
      label: 'Apple MDM Configuration',
      iframeUrl: 'https://xd.adobe.com/embed/3f06e8ed-b623-4355-aae1-135be1c1501d-6a55/',
      url: 'https://jumpcloud.com/simulations/mdm-configuration',
    },
    {
      label: 'User Portal Agent Install',
      iframeUrl: 'https://xd.adobe.com/embed/ba36b055-7aa5-48dd-8109-8d2a5baa1b0c-ef65/',
      url: 'https://jumpcloud.com/simulations/user-portal-agent-install',
    },
    {
      label: 'End user experience: Set Up a New Mac Device',
      iframeUrl: 'https://xd.adobe.com/embed/5aab9734-1d6d-4ba8-9d24-994ce9e074e8-0ff8/',
      url: 'https://jumpcloud.com/simulations/set-up-a-new-device',
    },
    {
      label: 'Conditional Access: Device Trust',
      iframeUrl: 'https://xd.adobe.com/embed/d9a5d73a-67ee-4d25-8956-b3aa1aa4b853-8cf6/',
      url: 'https://jumpcloud.com/simulations/conditional-access-device-trust',
    },
    {
      label: 'Account Takeover',
      iframeUrl: 'https://xd.adobe.com/embed/8e64eb46-ecec-479f-b253-00176b26fd84-db37/',
      url: 'https://jumpcloud.com/simulations/account-takeover',
    },
  ],
  [ItemTypeConsts.user]: [
    {
      label: 'Sync AD Users and Groups',
      iframeUrl: 'https://xd.adobe.com/embed/d20c865b-07a3-4e4d-b4aa-b7a76e1a2719-875f/',
      url: 'https://jumpcloud.com/simulations/sync-ad-users-and-groups',
    },
    {
      label: 'G Suite Sync',
      iframeUrl: 'https://xd.adobe.com/embed/557b19fc-b499-4271-bf5d-b73cc353aada-0028/',
      url: 'https://jumpcloud.com/simulations/g-suite-sync',
    },
    {
      label: 'Office 365 Sync',
      iframeUrl: 'https://xd.adobe.com/embed/a0e6ea85-4213-4197-4c7e-0a79cfe97c4d-d6d7/',
      url: 'https://jumpcloud.com/simulations/office-365-sync',
    },
  ],
};

export default {
  simulations,
};
